import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useJobDetail } from '../../../modules/apis/student/ai-tutor'
import type { GraphData, IJobOptionDetail, LevelData } from '../../../modules/apis/student/lesson'
import { useCafJobId, useJobOptions } from '../../../modules/apis/student/lesson'
import { aiTutorCafGraphDataQueryApi, aiTutorCafLevelDataQueryApi } from '../../../modules/react-query/queryApis'

export function useMyJob(defaultJob?: IJobOptionDetail | undefined): IJobOptionDetail | undefined {
  const { data: options } = useJobOptions()
  const { data: jobIdData } = useCafJobId()
  if (!options?.job || (!jobIdData?.job_id && jobIdData?.job_id !== null)) return defaultJob
  return options?.job?.find((job) => job.id === jobIdData?.job_id)
}

export function useJobCategory(jobId: number) {
  const { data: jobDetail } = useJobDetail(jobId)
  return jobDetail
}

const initialGraphData: GraphData = {
  complexity: {
    min: 0,
    max: 0,
    average: 0,
    top: 0,
    bottom: 0,
  },
  fluency: {
    min: 0,
    max: 0,
    average: 0,
    top: 0,
    bottom: 0,
  },
  accuracy: {
    min: 0,
    max: 0,
    average: 0,
    top: 0,
    bottom: 0,
  },
  pronunciation: {
    min: 0,
    max: 0,
    average: 0,
    top: 0,
    bottom: 0,
  },
}

export const useAITutorCafGraphData = (jobId: number) => {
  const pathParams = { jobId }
  return useQuery<GraphData, AxiosError>({
    queryKey: aiTutorCafGraphDataQueryApi.getQueryKey({ pathParams }),
    queryFn: aiTutorCafGraphDataQueryApi.getQueryFn({ pathParams }),

    initialData: initialGraphData,

    // onError: (e) => handleAxiosError(e),
    retry: 5,
    enabled: !!jobId,
  })
}

const initialLevelData = {
  levels: {
    complexity: '0',
    accuracy: '0',
    fluency: '0',
    pronunciation: '0',
  },
  percents: {
    complexity: 100,
    accuracy: 100,
    fluency: 100,
    pronunciation: 100,
  },
}

export const useAITutorCafLevelData = (jobId: number) => {
  const pathParams = { jobId }
  return useQuery<LevelData, AxiosError>({
    queryKey: aiTutorCafLevelDataQueryApi.getQueryKey({ pathParams }),
    queryFn: aiTutorCafLevelDataQueryApi.getQueryFn({ pathParams }),
    initialData: initialLevelData,
    // onError: (e) => handleAxiosError(e),
    retry: 5,
    enabled: !!jobId,
  })
}
